<template>

  <v-card outlined :loading="isLoading" >

      <v-card-title>
        <lang t="BUNDLE-STATS-DIMENSIONS_VARIANCES"></lang>
        <v-select
          v-model="typeSelected"
          :items="['width', 'height', 'length', 'weight']"
          dense
          flat
          hide-details
          height="20"
          @change="onChangeType"
          style="max-width: 80px; margin-left: auto;">
        </v-select>
      </v-card-title>

      <v-card-text v-if="!isLoading">
          <apexchart :key="stats.series" height='480px'  :options="stats.options" :series="stats.series"></apexchart>
      </v-card-text>

  </v-card>

</template>

<script>
// https://apexcharts.com/vue-chart-demos/
import VueApexCharts from 'vue-apexcharts'

export default {

    components: {
        apexchart: VueApexCharts
    },

    props: {

        bundleId: {
          type: Number,
          default: null
        },

        show: {
          type: Boolean,
          default: false
        }

    },

    data: function() {

        return {

            typeSelected: 'width',
            isLoading: true,

            statsData: null,

            stats: {
                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                        toolbar: {
                          show: true,
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    plotOptions: {
                      bar: {
                        borderRadius: 2,
                        columnWidth: '2px',
                      }
                    },
                    grid: {
                      row: {
                        colors: ['#fff', '#f5f5f5']
                      }
                    },
                    xaxis: {
                      type: 'category',
                      labels: {
                        rotateAlways: true,
                        show: true,
                        rotate: -45
                      },
                    },
                    yaxis: {
                      tickAmount: 5,
                      title: {
                        text: 'Count of Differences',
                      },

                    }
                },

            },

        }
    },

    created() {


    },

    watch: {

      'show': {
        immediate: true,
        handler(value) {
          if(value) {
            this.initialize();
          }
        }
      }

    },

    mounted() {

    },

    methods: {

        onChangeType(val) {

          this.isLoading = true;

          this.stats.series = [{
              name: val,
              data: Object.values(this.statsData[val])
          }];

          let cats = Object.keys(this.statsData[val]);
          this.stats.options.xaxis.categories = cats;
          this.isLoading = false;

        },

        initialize() {
          let bundleId = this.bundleId;
          
          this.axios
            .get(this.$config.api + `/measurements/${bundleId}/countOfDifferences`)
            .then((res) => {

              this.statsData = res.data;

              this.stats.series = [
                {
                  name: 'Width',
                  data: Object.values(res.data.width)
                }
              ]

              this.stats.options.xaxis.categories = Object.keys(res.data.width);
              this.isLoading = false;

            }).catch(err => {
              console.error(err);
            }); 
          
        },


    }


}

</script>

<style lang="scss" scoped>

  .dashboard {

    .statsTotal {
      font-size: 2.6rem;
      line-height: 1;
      font-weight: 600;
      position: relative;
      text-align: center;
    }
    .statsPercent {
      text-align: center;
      padding: 10px 0 0 0;
    }

    @media (max-width: 768px) {
      .statsTotal {
        font-size: 24px;
      }
    }

    ::v-deep .apexcharts-toolbar {
      z-index: 5;
    }

    .small-box {
      min-width: 160px;
    }
  }
</style>
